module.exports = __webpack_public_path__ + "img/pin_.f576b24d.svg";